/**
 * Canonical occupation (job-title) list, sourced from Databricks
 * `minetwin_practice.reference.employee_roster.job_title` via
 * `useDatabricksTaxonomy`. Cloud Lead + Samuel 2026-06-17: occupations
 * are job titles like "Haul Truck Operator"; they are NOT orientation
 * display names (training sessions live in the MineTwin module's
 * `visible_orientations` view and are served by `useOrientations`).
 *
 * Return shape `{ occupations: { id, title }[], isReady, error }`.
 * `title` carries the `job_title` column value verbatim; `id` is the
 * same string (no caller reads it separately today, but kept so the
 * row shape stays stable if a future schema swap introduces a real id).
 */

import { useDatabricksTaxonomy } from './useDatabricksTaxonomy';

export type OccupationRow = {
  id: string;
  title: string;
};

export function useOccupations(): {
  occupations: OccupationRow[];
  isReady: boolean;
  error: string | null;
} {
  const { rows, isReady, error } = useDatabricksTaxonomy();
  return { occupations: rows, isReady, error };
}
